import axios, { AxiosResponse } from 'axios';
import { IUserInfo } from 'app/modules/contract/model/userInfo.model';
import { IPaymentModel } from '../model/payment.model';

export interface IfinancialApi {
  checkBicIban(userInfo: IUserInfo): Promise<AxiosResponse<any>>;
  getHashMack(paymentModel: IPaymentModel): Promise<AxiosResponse<any>>;
}

export class FinancialApi implements IfinancialApi {
  async checkBicIban(userInfo: any): Promise<AxiosResponse<any>> {
    let iban;
    let bic;
    if (userInfo.bankInfos) {
      iban = userInfo.bankInfos.iban;
      bic = userInfo.bankInfos.bic;
    }
    if (userInfo.bankingInfo) {
      iban = userInfo.bankingInfo.iban;
      bic = userInfo.bankingInfo.bic;
    }
    return axios.post('/api/finance/checkBicIban', { iban, bic });
  }

  async getHashMack(paymentModel: IPaymentModel): Promise<AxiosResponse<any>> {
      axios.post('/api/finance/savePayboxTransaction', {
      datePayment: paymentModel.datePayment,
      email: paymentModel.email,
      redirectAfterPayment: paymentModel.redirectAfterPayment,
      subscriptionNumber: paymentModel.subscriptionNumber,
      numberOfScheduleLines: paymentModel.numberOfScheduleLines,
      singlePrice: paymentModel.singlePrice,
      cotisationDatas: paymentModel.cotisationDatas,
      total: paymentModel.total,
    });
    
    return axios.post('/api/finance/getHashCode', {
      datePayment: paymentModel.datePayment,
      email: paymentModel.email,
      redirectAfterPayment: paymentModel.redirectAfterPayment,
      subscriptionNumber: paymentModel.subscriptionNumber,
      numberOfScheduleLines: paymentModel.numberOfScheduleLines,
      singlePrice: paymentModel.singlePrice,
      total: paymentModel.total,
    });
  }
}
